import { StatCard } from '@/client/components/common/StatCard';
import { trpc } from '@/client/utils/trpc';
import type { RouterOutputs } from '@/client/utils/trpc';
import { CalendarDays, Clock, Coins, FolderKanban } from 'lucide-react';

type Employee = RouterOutputs['employees']['list'][number];

interface PersonStatCardsProps {
  person: Employee;
}

export function PersonStatCards({ person }: PersonStatCardsProps) {
  const now = new Date();
  const monthName = now.toLocaleString('default', { month: 'long' });

  const { data: hoursData } = trpc.employees.getHoursThisMonth.useQuery(
    { id: person.id },
    { enabled: !!person.id },
  );

  const rateLabel = person.rate != null ? `${person.rate} / ${person.rate_type ?? '?'}` : '—';

  const joinedDate = new Date(person.created_at).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <div className="mb-6 grid grid-cols-2 gap-3 2xl:grid-cols-4">
      <StatCard label="Rate" value={rateLabel} icon={Coins} tone="good" />
      <StatCard
        label={`Hours · ${monthName}`}
        value={hoursData != null ? `${hoursData.total_hours}h` : '—'}
        icon={Clock}
        tone="primary"
      />
      <StatCard label="Projects" value={person.project_count} icon={FolderKanban} tone="warn" />
      <StatCard label="Joined" value={joinedDate} icon={CalendarDays} />
    </div>
  );
}
